import { render, staticRenderFns } from "./Marcas.view.vue?vue&type=template&id=0d0cd5c7"
import script from "./Marcas.view.vue?vue&type=script&lang=js"
export * from "./Marcas.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports